/**
 * 数据适配基类
 */
export class Adapter {
    /**
     * 获取矢量数据类型
     */
    get type() {
        return this._type;
    }
    /**
      * 构造函数
      * @param {GeometryType} type - 矢量数据类型
      */
    constructor(type) {
        this._type = type;
    }
}
